import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=038bc530&scoped=true"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"
import style0 from "./Total.vue?vue&type=style&index=0&id=038bc530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038bc530",
  null
  
)

export default component.exports